import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { useNavigate } from "react-router-dom";

export const commentsApi = createApi({
  reducerPath: 'comments',
  baseQuery: fetchBaseQuery({
    baseUrl: import.meta.env.VITE_API ,
    prepareHeaders: (headers, { getState }) => {
      const token = getState().userSlice?.token;
      
      if (token) {
        headers.set('Authorization', `Bearer ${token}`);
      }
      
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getAllComments: builder.query({
      query: (query) => ({
        url: query ? query : "",
        method: 'GET',
      }),
    }),
    putComments: builder.mutation({
      query: (commentData ) => ({
        url: "comment",
        method: "POST",
        body: {
            "product_code": commentData.prCode,
            "variant_code": commentData.varCode,
            "name": commentData.username,
            "content": commentData.content,
            "show_name": commentData.show_name
        },
      }),
      transformResponse: (response) => response.data,
    }),
  }),
});

export const { useGetAllCommentsQuery , usePutCommentsMutation } = commentsApi;
